import {Api} from '../../../Api.js'

const RESOURCE = 'tax'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    import(data) {
        return Api().post(this.resource + '/import', data)
    },
}


// WEBPACK FOOTER //
// ./src/modules/config/tax/TaxService.js